export default "/_next/static/chunks/fonts/GraphikMediumItalic-56decae11f040d744e6051bfcc79d734.otf";